import { CLIENT_GET_ADMIN_STATE } from "@/graphql/operations/client.queries";
import { useQuery } from "@apollo/client";

export function useAdminPageState() {
  const { data } = useQuery(CLIENT_GET_ADMIN_STATE, { fetchPolicy: "cache-only" });

  return data?.adminPageState;
}
